import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtMoney } from "@/lib/utils";

const SOURCE_LABEL = {
  team: "Team Level",
  royalty: "Royalty",
  star_club: "Global Club",
  play: "Play Card",
  other: "Other",
};

export default function IncomeHistory() {
  const [data, setData] = useState({ rows: [], summary: {} });
  const [filter, setFilter] = useState("all");
  useEffect(() => { (async () => {
    try {
      const r = await api.get("/me/income-history");
      setData(r.data);
    } catch (err) {
      console.warn("Income history load failed:", err?.message);
    }
  })(); }, []);

  const filtered = data.rows.filter((r) => {
    if (filter === "all") return true;
    return r.source.startsWith(filter);
  });

  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Income</div>
        <h1 className="font-display text-4xl mt-1">Earnings History</h1>
      </div>

      <div className="grid md:grid-cols-5 gap-4">
        {Object.entries(SOURCE_LABEL).map(([k, label]) => (
          <button
            key={k}
            onClick={() => setFilter(k === filter ? "all" : k)}
            data-testid={`income-filter-${k}`}
            className={`lt-card p-4 text-left transition ${filter === k ? "border-[#D4AF37]" : ""}`}
          >
            <div className="overline">{label}</div>
            <div className="font-display text-2xl tabular mt-1">${fmtMoney(data.summary?.[k] || 0)}</div>
          </button>
        ))}
      </div>

      <div className="lt-card p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="overline">{filter === "all" ? "All entries" : `Filtered: ${SOURCE_LABEL[filter]}`}</div>
          {filter !== "all" && <button className="text-xs text-neutral-400 hover:text-white" onClick={() => setFilter("all")}>Clear filter</button>}
        </div>
        <div className="overflow-x-auto -mx-1">
        <table className="lt-table">
          <thead><tr><th>When</th><th>Source</th><th>Note</th><th className="text-right">Amount</th></tr></thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id}>
                <td className="text-neutral-400">{new Date(r.created_at).toLocaleString()}</td>
                <td>{r.source}</td>
                <td className="text-neutral-400">{r.note}</td>
                <td className="text-right tabular gold-text" data-testid={`income-row-amount-${r.id}`}>+${fmtMoney(r.amount)}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={4} className="text-center text-neutral-500 py-6">No income entries.</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
